import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import csharp from '../assets/csharp.png';
import dotnet from '../assets/dotnet.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';

export default {
  dotnet,
  csharp,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  git,
  html,
  javascript,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  profile,
  circle,
};
